export default __webpack_public_path__ + "static/media/lds-logo_en.b59efad770547cd5.svg";